
import { supabase } from '@/integrations/supabase/client';

/**
 * Checks if the current user has admin status using multiple verification methods
 * for consistent role verification across the application
 */
export const checkAdminStatus = async () => {
  try {
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      console.error('Error fetching session:', sessionError);
      return { isAdmin: false, error: sessionError };
    }
    
    if (!sessionData.session) {
      console.log('No active session found');
      return { isAdmin: false };
    }
    
    // Always log user ID and email for debugging
    console.log(`Checking admin status for user: ${sessionData.session.user.email} (ID: ${sessionData.session.user.id})`);
    
    // PRIMARY METHOD: Check directly with email in client_onboarding
    // This is most reliable because email is consistent across auth.users and client_onboarding
    console.log('Checking admin status via email query...');
    const { data: onboardingData, error: onboardingError } = await supabase
      .from('client_onboarding')
      .select('role')
      .eq('email', sessionData.session.user.email)
      .maybeSingle();
        
    if (onboardingError) {
      console.error('Error checking admin status via email query:', onboardingError);
      return { isAdmin: false, error: onboardingError };
    }
    
    if (onboardingData) {
      const isAdmin = onboardingData.role === 'admin';
      console.log(`Admin check result: ${isAdmin} (User: ${sessionData.session.user.email})`);
      return { isAdmin };
    }
    
    // User not found in onboarding table
    console.log('No onboarding data found for email:', sessionData.session.user.email);
    return { isAdmin: false };
    
  } catch (error) {
    console.error('Error checking admin status:', error);
    return { isAdmin: false, error };
  }
};
